export const environment = {
  production: false,
  token: "Token",
  userDomain: "compass-usa\\",
  serverInfo: {
    ssoUrl: "__/migrationhipaa/teamflow/sso/url__",
    clientId: "__/migrationhipaa/teamflow/sso/clientid__",
    clientSecret: "__/migrationhipaa/teamflow/sso/secret__",
    redirect_uri: "__/migrationhipaa/teamflow/sso/redirecturl__",
  },

  getAPIUrl() {
    return "__/migrationhipaa/teamflow/api__" + "/api/";
  },

  getSSO(callType) {
    const currentEnv = this.serverInfo;

    switch (callType) {
      case "href":
        return (
          currentEnv.ssoUrl +
          "authorize?response_type=code&client_id=" +
          currentEnv.clientId +
          "&redirect_uri=" +
          currentEnv.redirect_uri
        );
      case "token":
        return (
          currentEnv.ssoUrl +
          "accessToken?grant_type=authorization_code&client_id=" +
          currentEnv.clientId +
          "&redirect_uri=" +
          currentEnv.redirect_uri +
          "&client_secret=" +
          currentEnv.clientSecret +
          "&code="
        );
      case "user":
        return currentEnv.ssoUrl + "profile?access_token=";
      default:
        return "";
    }
  },
};
